
export const environment = {
  production: true,
  acsEndPointUrl : 'https://acspoc1.communication.azure.com',
  acsMFEUrl : 'https://qa-afrisure-uad-api.insure.digital',
  acsEncKey : 'your_secret_key',
  afriSureUat : 'https://qa-common-uad.insure.digital/auth/login?domainId=F3A82412-186C-404C-B3D8-EF9D1A49AE77',
  domainDetailUrl:'https://qa-common-uad-api.insure.digital'
};
